export const getSupportedAudioMimeType = () => {
  try {
    if (typeof window !== 'undefined' && 'MediaRecorder' in window) {
      const candidates = [
        'audio/webm;codecs=opus',
        'audio/webm',
        'audio/ogg;codecs=opus',
        'audio/ogg',
        'audio/mp4',
        'audio/mpeg',
      ]
      const { MediaRecorder } = window
      return candidates.find((t) => MediaRecorder.isTypeSupported(t))
    }
  } catch {
    // ignore
  }
  return undefined
}

export const getFileExtension = (type: string) => {
  if (type.includes('ogg')) return 'ogg'
  if (type.includes('mp4')) return 'm4a'
  if (type.includes('mpeg')) return 'mp3'
  return 'webm'
}
